import {showFactionDetailsPageGraphic} from "./graphics.js";
import {commaSeparate, gameLimits} from "../modules/helpers.js";
import {getPointsHtml, hideContent} from "./ui-helpers.js";
import {globals} from "../modules/globals.js";
import {playSoundEffect} from "./sounds.js";
import {
    addFaction,
    addFactionMembers,
    disbandFactionRequest,
    getFactionSuperstarsRequest,
    getSuperstarsAvailableForFaction,
    removeFactionLeaderRequest,
    removeFactionMembers,
    setFactionLeader
} from "../modules/factions.js";
import {getRosterMemberNameData} from "../modules/rosters.js";
import {manageHandler} from "./game-menu.js";

function getViewFactionHtml(faction) {
    // Get disbanded text and class
    let disbandedHtml = '';
    let disbandedClass = '';
    if (faction['disbanded']) {
        disbandedHtml = '<div class="margin-top-2">Disbanded</div>';
        disbandedClass = ' light-opaque';
    }

    // Get superstar names
    let superstarNames = Array.from(faction['superstars'], function (superstar) {
        if (superstar['leader']) {
            return '<span class="medium-grey">' + superstar['name'] + '</span>'
        }
        else {
            return superstar['name']
        }
    });

    // Get html
    return '<div class="view-factions-item' + disbandedClass + '" data-uid="' + faction['uid'] + '">' +
            '<div class="margin-bottom-8">' +
                '<span>' + faction['name'] + '</span>' +
                '<span class="float-right light-grey">' +
                    faction['reputationData']['reputation'] + ' REP' +
                '</span>' +
            '</div>' +
            '<div class="light-grey">' +
                commaSeparate(superstarNames) +
                disbandedHtml +
            '</div>' +
        '</div>';
}

function showViewFactionDetailsPage(data, isCompetitorFaction, element) {
    if (typeof(element) === 'undefined') element = null;

    let parentElement = $('.faction-details-container');

    // Add element to data
    parentElement.data('element', element);

    // Name
    parentElement.find('.faction-details-name').html(data['name']);

    // Graphic
    $('.faction-details-graphic').html('');
    let el = parentElement.find('.faction-details-graphic');
    let matchData = {'type': 'singles', 'larger_tag': data['graphic'].length, 'faction_graphic': true};
    if (data['graphic'].length > 10) {
        matchData = {'type': 'singles'}
    }
    showFactionDetailsPageGraphic(data['graphic'], el, matchData);
    $('.faction-details').data('graphic', data['graphic']);

    // Leader
    let factionLeader = data['superstars'].filter(function (obj) {
        return obj['leader'] === true;
    })[0];
    let factionLeaderHtml = (factionLeader) ? getFactionSuperstarsHtml([factionLeader]) : 'None';
    parentElement.find('.faction-details-leader').html(factionLeaderHtml);

    // Other superstars
    let otherSuperstars = data['superstars'].filter(function (obj) {
        return obj['leader'] !== true;
    });
    let otherSuperstarsHtml = getFactionSuperstarsHtml(otherSuperstars, true);
    parentElement.find('.faction-details-superstars').html(otherSuperstarsHtml);

    // Former members if present
    if (data['formerMembers'] && data['formerMembers'].length > 0) {
        let formerMembersHtml = '';
        data['formerMembers'].forEach(function(formerMember) {
            formerMembersHtml += '<div class="margin-bottom-4">' + formerMember + '</div>'
        });
        parentElement.find('.faction-details-former-members').html(formerMembersHtml);
        parentElement.find('.faction-details-former-members').parent().show();
    }
    else {
        parentElement.find('.faction-details-former-members').html('');
        parentElement.find('.faction-details-former-members').parent().hide();
    }

    // Show all buttons
    parentElement.find('.faction-details-buttons').children().show();

    // Hide 'remove leader' button if no leader
    if (factionLeader) {
        parentElement.find('.remove-faction-leader-button').show()
    }
    else {
        parentElement.find('.remove-faction-leader-button').hide()
    }

    // Show disbanded, hide buttons if disbanded
    if (data['disbanded']) {
        parentElement.find('.faction-details-disbanded').show();
        parentElement.find('.faction-details-buttons').children(':not(.back-to-view-factions-button)').hide();
    }
    else {
        parentElement.find('.faction-details-disbanded').hide();
        parentElement.find('.faction-details-buttons').children(':not(.back-to-view-factions-button)').show();
    }

    // Hide all buttons except 'back' if competitor faction
    if (isCompetitorFaction) {
        parentElement.find('.faction-details-buttons').children(':not(.back-to-view-factions-button)').hide();
    }

    // Reputation and progress
    let reputationHtml = 'REP {0}'.format(data['reputationData']['reputation']);
    if (data['reputationData']['reputation'] >= 10) {
        reputationHtml += '<span class="margin-left-8 red">MAX</span>';
    }
    parentElement.find('.faction-details-reputation').html(reputationHtml);
    let reputationProgressHtml = getFactionReputationProgressHtml(data['reputationData']);
    $('.faction-details-reputation-progress').html(reputationProgressHtml);

    // Add uid to data
    parentElement.data('factionUid', data['uid']);

    // Show faction details container
    hideContent($());
    parentElement.fadeIn('slow');
    parentElement[0].scrollIntoView();
}

function getFactionSuperstarsHtml(superstarsData, addSuperstarMargins, highlightLeader) {
    let factionSuperstarsHtml = '';
    superstarsData.forEach(function(superstarData) {
        // Name
        let superstarHtml;
        if (superstarData['leader'] && highlightLeader) {
            superstarHtml = '<span class="dark-grey">' + superstarData['name'] + '</span>'
        }
        else {
            superstarHtml = superstarData['name']
        }

        // Championships
        if (superstarData['championshipsNames']) {
            superstarHtml += '<span class="gold margin-left-8">' + superstarData['championshipsNames'] + '</span>'
        }

        // Manager
        if (superstarData['fullTimeManager']) {
            superstarHtml += ' <span class="light-grey">(Manager)</span>'
        }

        // Margins
        if (addSuperstarMargins) {
            factionSuperstarsHtml += '<div class="margin-bottom-4">' + superstarHtml + '</div>';
        }
        else {
            factionSuperstarsHtml += '<div>' + superstarHtml + '</div>';
        }
    });
    return factionSuperstarsHtml;
}

function getFactionReputationProgressHtml(reputationData) {
    let progressPercentage = reputationData['progressPercentage'];
    if (progressPercentage <= 0) {
        progressPercentage = 1
    }
    return '<div class="progress-under compact help-text" title="' + reputationData['xp'] + ' / ' + reputationData['xpToNextReputation'] + ' XP">' +
        '<div class="progress compact" style="width:' + progressPercentage + '%">' + '</div>' +
        '</div>';
}

async function loadAddFactionPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getSuperstarsAvailableForFaction();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showAddFactionPageData(data);
}

function showAddFactionPageData(data) {

    const $addFactionContainer = $('.add-faction-container');

    // Reset add faction inputs
    $addFactionContainer.find('.select-faction-member').slice(2).parent().remove();
    $('.add-faction-container .add-faction-name').val('');

    // Reset faction member selects
    let selectFactionMemberDiv = $addFactionContainer.find('.select-faction-member');
    selectFactionMemberDiv.html('');

    // Add available superstars to faction member and faction leader selects
    data['availableSuperstars'].forEach(function (factionSuperstar) {
        selectFactionMemberDiv.append($("<option />").val(factionSuperstar['uid']).text(factionSuperstar['name']));
    });

    // Select second option for second faction member select
    selectFactionMemberDiv.eq(1).find(":selected").next().prop('selected', true);

    // Update faction leader select
    updateFactionLeaderSelect($addFactionContainer);

    $addFactionContainer.fadeIn('slow');
}

async function loadAddFactionMembersPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    let factionUid = $('.faction-details-container').data('factionUid');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getSuperstarsAvailableForFaction({factionUid});
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showAddFactionMembersPageData(data);
}

function showAddFactionMembersPageData(data) {
    const $addFactionMembersContainer = $('.add-faction-members-container');

    // Reset faction member selects
    $addFactionMembersContainer.find('.select-faction-member').not(":eq(0)").parent().remove();

    let selectFactionMemberDiv = $addFactionMembersContainer.find('.select-faction-member');
    selectFactionMemberDiv.html('');
    data['availableSuperstars'].forEach(function (factionSuperstar) {
        selectFactionMemberDiv.append($("<option />").val(factionSuperstar['uid']).text(factionSuperstar['name']));
    });
    $addFactionMembersContainer.fadeIn('slow');
}

async function loadRemoveFactionMembersPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    let factionUid = $('.faction-details-container').data('factionUid');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getFactionSuperstarsRequest({factionUid});
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showRemoveFactionMembersPageData(data);
}

function showRemoveFactionMembersPageData(data) {
    const $removeFactionMembersContainer = $('.remove-faction-members-container');

    // Reset faction member selects
    $removeFactionMembersContainer.find('.select-faction-member').not(":eq(0)").parent().remove();

    let selectFactionMemberDiv = $removeFactionMembersContainer.find('.select-faction-member');
    selectFactionMemberDiv.html('');
    data['factionSuperstars'].forEach(function (factionSuperstar) {
        selectFactionMemberDiv.append($("<option />").val(factionSuperstar['uid']).text(factionSuperstar['name']));
    });
    $removeFactionMembersContainer.fadeIn('slow');
}

async function loadSetFactionLeaderPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    let factionUid = $('.faction-details-container').data('factionUid');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getFactionSuperstarsRequest({factionUid});
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showSetFactionLeaderPageData(data);
}

function showSetFactionLeaderPageData(data) {
    let selectFactionLeaderDiv = $('.set-faction-leader-container .select-faction-leader');
    selectFactionLeaderDiv.html('');
    data['factionSuperstars'].forEach(function (factionSuperstar) {
        selectFactionLeaderDiv.append($("<option />").val(factionSuperstar['uid']).text(factionSuperstar['name']));
    });
    $('.set-faction-leader-container').fadeIn('slow');
}

async function loadChangeFactionNamePage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    let type = 'faction';
    let factionUid = $('.faction-details-container').data('factionUid');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getRosterMemberNameData({uid: factionUid, type: type});
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showChangeFactionNamePageData(data, factionUid, type);
}

function showChangeFactionNamePageData(data, factionUid, type) {
    const $changeNameContainer = $('#change-name-container');
    $('.change-name-member-name').text(data['name']);
    $('#change-name-container .change-name-input').val(data['name']);
    $changeNameContainer.data('uid', factionUid);
    $changeNameContainer.data('type', type);
    $changeNameContainer.fadeIn();
}

async function getAddFactionRequest() {

    if (globals.requestRunning) {
        return;
    }

    let parent = $('.add-faction-container');
    let factionName = parent.find('.add-faction-name').val();
    let leaderSuperstarUid = parseInt(parent.find('.select-faction-leader').find(':selected').val());
    let superstarUids = Array.from(parent.find('.select-faction-member'), function (x) {
        return parseInt($(x).find(':selected').val());
    });

    // Validate
    if (factionName.length <= 0) {
        notie.alert({type: 3, text: "Enter a name for the Faction"});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addFaction(factionName, superstarUids, leaderSuperstarUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddFactionData(data);
}

function showAddFactionData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let html = '<span class="display-block">' +
            data['factionName'] + " added" +
            '</span>';

        notie.alert({type: 4, text: html, stay: true});

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to view factions
        setTimeout(function () {
            $('#view-factions-menu-button').trigger('click');
        }, 1200);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to add a faction."});
        }
        if (data['error'] === 'already-present') {
            notie.alert({type: 3, text: "A faction with that name already exists."});
        }
        if (data['error'] === 'team-already-present') {
            notie.alert({type: 3, text: "A team with that name already exists."});
        }
        if (data['error'] === 'superstar-not-found') {
            notie.alert({type: 3, text: "One of the selected superstars could not be found. Please try again."});
        }
        if (data['error'] === 'already-in-faction') {
            notie.alert({type: 3, text: data['errorSuperstarName'] + " is already in another faction."});
        }
        if (data['error'] === 'leader-superstar-not-present') {
            notie.alert({type: 3, text: "The leader needs to be a member of the faction."});
        }
        if (data['error'] === 'maximum-superstars') {
            notie.alert({type: 3, text: `You cannot have more than ${gameLimits.maxFactionSuperstars} members in a faction.`});
        }
        if (data['error'] === 'minimum-superstars') {
            notie.alert({type: 3, text: "You cannot have less than 2 members in a faction."});
        }
    }
}

async function getDisbandFactionRequest() {

    if (globals.requestRunning) {
        return;
    }

    let factionUid = $('.faction-details-container').data('factionUid');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await disbandFactionRequest(factionUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showDisbandFactionData(data);
}

function showDisbandFactionData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let html = '<span class="display-block">' +
            data['factionName'] + " have disbanded" +
            '</span>';

        notie.alert({type: 4, text: html, stay: true});

        // Go back to view factions
        const $viewFactionsMenuButton = $('#view-factions-menu-button');
        setTimeout(function () {
            if ($viewFactionsMenuButton.length <= 0) {
                manageHandler();
                $('#manage-roster').trigger('click');
            }
            $viewFactionsMenuButton.trigger('click');
        }, 800);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'faction-not-found') {
            notie.alert({type: 3, text: 'That faction could not be found. Please try again.'});
        }
    }
}

async function getAddFactionMembersRequest() {

    if (globals.requestRunning) {
        return;
    }

    let factionUid = $('.faction-details-container').data('factionUid');
    let superstarUids = Array.from($('.add-faction-members-container .select-faction-member'), function (x) {
        return parseInt($(x).find(':selected').val());
    });

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addFactionMembers(factionUid, superstarUids);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddFactionMembersData(data);
}

function showAddFactionMembersData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let xpChangeHtml = '';
        if (data['xpChange'] < 0) {
            xpChangeHtml =
                '<span class="red margin-left-5">- ' + (data['xpChange'] * -1) + ' XP' + '</span>';
        } else {
            xpChangeHtml =
                '<span class="green margin-left-5">+ ' + data['xpChange'] + ' XP' + '</span>';
        }

        let addedToFactionVerb = (data['addedSuperstarsNames'].length < 2) ? 'was' : 'were';
        let html = '<span class="display-block">' +
            commaSeparate(data['addedSuperstarsNames']) + " " + addedToFactionVerb + " added to the faction" +
            xpChangeHtml +
            '</span>';

        notie.alert({type: 4, text: html, stay: true});

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to view factions
        const $viewFactionsMenuButton = $('#view-factions-menu-button');
        setTimeout(function () {
            if ($viewFactionsMenuButton.length <= 0) {
                manageHandler();
                $('#manage-roster').trigger('click');
            }
            $viewFactionsMenuButton.trigger('click');
        }, 1200);

    } else {
        playSoundEffect('error');
        if (data['error'] === 'faction-not-found') {
            notie.alert({type: 3, text: "That faction could not be found. Please try again."});
        }
        if (data['error'] === 'superstar-not-found') {
            notie.alert({type: 3, text: "One of the superstars selected could not be found. Please try again."});
        }
        if (data['error'] === 'already-in-faction') {
            notie.alert({type: 3, text: data['errorSuperstarName'] + " is already in another faction."});
        }
        if (data['error'] === 'already-member-of-faction') {
            notie.alert({type: 3, text: data['errorSuperstarName'] + " is already part of this faction."});
        }
        if (data['error'] === 'maximum-superstars') {
            notie.alert({type: 3, text: `You cannot have more than ${gameLimits.maxFactionSuperstars} members in a faction.`});
        }
    }
}

async function getRemoveFactionMembersRequest() {

    if (globals.requestRunning) {
        return;
    }

    let factionUid = $('.faction-details-container').data('factionUid');
    let superstarUids = Array.from($('.remove-faction-members-container .select-faction-member'), function (x) {
        return parseInt($(x).find(':selected').val());
    });

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await removeFactionMembers(factionUid, superstarUids);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRemoveFactionMembersData(data);
}

function showRemoveFactionMembersData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let xpChangeHtml = '';
        if (data['xpChange'] < 0) {
            xpChangeHtml =
                '<span class="red margin-left-5">- ' + (data['xpChange'] * -1) + ' XP' + '</span>';
        } else {
            xpChangeHtml =
                '<span class="green margin-left-5">+ ' + data['xpChange'] + ' XP' + '</span>';
        }

        let removedFromFactionVerb = (data['removedSuperstarsNames'].length < 2) ? 'was' : 'were';
        let html = '<span class="display-block">' +
            commaSeparate(data['removedSuperstarsNames']) + " " + removedFromFactionVerb + " removed from the faction" +
            xpChangeHtml +
            '</span>';

        notie.alert({type: 4, text: html, stay: true});

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }

        // Go back to view factions
        const $viewFactionsMenuButton = $('#view-factions-menu-button');
        setTimeout(function () {
            if ($viewFactionsMenuButton.length <= 0) {
                manageHandler();
                $('#manage-roster').trigger('click');
            }
            $viewFactionsMenuButton.trigger('click');
        }, 1200);

    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'faction-not-found') {
            notie.alert({type: 3, text: "That faction could not be found. Please try again."});
        }
        if (data['error'] === 'superstar-not-found') {
            notie.alert({
                type: 3,
                text: "One of the superstars selected could not be found. Please try again."
            });
        }
        if (data['error'] === 'not-member-of-faction') {
            notie.alert({type: 3, text: data['errorSuperstarName'] + " is not part of this faction."});
        }
        if (data['error'] === 'minimum-superstars') {
            notie.alert({type: 3, text: "You cannot have less than 2 members in a faction."});
        }
    }
}

async function getRemoveFactionLeaderRequest() {

    if (globals.requestRunning) {
        return;
    }

    let factionUid = $('.faction-details-container').data('factionUid');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await removeFactionLeaderRequest(factionUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRemoveFactionLeaderData(data);
}

function showRemoveFactionLeaderData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let xpChangeHtml = '';
        if (data['xpChange'] < 0) {
            xpChangeHtml =
                '<span class="red margin-left-5">- ' + (data['xpChange'] * -1) + ' XP' + '</span>';
        } else {
            xpChangeHtml =
                '<span class="green margin-left-5">+ ' + data['xpChange'] + ' XP' + '</span>';
        }

        let html = '<span class="display-block">' +
            "Leader of " + data['factionName'] + " was removed" +
            xpChangeHtml +
            '</span>';

        notie.alert({type: 4, text: html, stay: true});

        // Go back to view factions
        const $viewFactionsMenuButton = $('#view-factions-menu-button');
        setTimeout(function () {
            if ($viewFactionsMenuButton.length <= 0) {
                manageHandler();
                $('#manage-roster').trigger('click');
            }
            $viewFactionsMenuButton.trigger('click');
        }, 1200);
    } else {
        playSoundEffect('error');
        if (data['error'] === 'faction-not-found') {
            notie.alert({type: 3, text: 'That faction could not be found. Please try again.'});
        }
        if (data['error'] === 'leader-not-present') {
            notie.alert({type: 3, text: 'That faction does not have a leader.'});
        }
    }
}

async function getSetFactionLeaderRequest() {

    if (globals.requestRunning) {
        return;
    }

    let factionUid = $('.faction-details-container').data('factionUid');
    let leaderSuperstarUid = parseInt($('.set-faction-leader-container .select-faction-leader').find(':selected').val());

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await setFactionLeader(factionUid, leaderSuperstarUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showSetFactionLeaderData(data);
}

function showSetFactionLeaderData(data) {
    if (!data['error']) {
        playSoundEffect('success');

        let xpChangeHtml = '';
        if (data['xpChange'] < 0) {
            xpChangeHtml =
                '<span class="red margin-left-5">- ' + (data['xpChange'] * -1) + ' XP' + '</span>';
        } else {
            xpChangeHtml =
                '<span class="green margin-left-5">+ ' + data['xpChange'] + ' XP' + '</span>';
        }

        let html = '<span class="display-block">' +
            data['leaderSuperstarName'] + " was set as the leader" +
            xpChangeHtml +
            '</span>';

        notie.alert({type: 4, text: html, stay: true});

        // Go back to view factions
        const $viewFactionsMenuButton = $('#view-factions-menu-button');
        setTimeout(function () {
            if ($viewFactionsMenuButton.length <= 0) {
                manageHandler();
                $('#manage-roster').trigger('click');
            }
            $viewFactionsMenuButton.trigger('click');
        }, 1200);
    } else {
        playSoundEffect('error');
        if (data['error'] === 'faction-not-found') {
            notie.alert({type: 3, text: 'That faction could not be found. Please try again.'});
        }
        if (data['error'] === 'leader-superstar-not-found') {
            notie.alert({type: 3, text: 'That superstar could not be found. Please try again.'});
        }
        if (data['error'] === 'leader-superstar-not-present') {
            notie.alert({type: 3, text: "The leader needs to be a member of the faction."});
        }
    }
}

function updateFactionLeaderSelect(parent) {
    let selectFactionMemberDivs = parent.find('.select-faction-member');
    let selectFactionLeaderDiv = parent.find('.select-faction-leader');
    let selectedValue = selectFactionLeaderDiv.val();

    // Reset
    selectFactionLeaderDiv.html('');
    selectFactionLeaderDiv.append($('<option selected value>None</option>'));

    // Add faction members selected as options, don't add duplicates
    selectFactionMemberDivs.each(function(i, e) {
        let selectedOption = $(e).find('option:selected');
        if (selectFactionLeaderDiv.find('option[value="' + selectedOption.val() + '"]').length <= 0) {
            selectFactionLeaderDiv.append($("<option />").val(selectedOption.val()).text(selectedOption.text()))
        }
    });

    // If previously selected value found, select it, otherwise select none
    if (selectFactionLeaderDiv.find('option[value="' + selectedValue + '"]').length > 0) {
        selectFactionLeaderDiv.val(selectedValue);
    }
    else {
        selectFactionLeaderDiv.val('');
    }
}

export {getViewFactionHtml, showViewFactionDetailsPage, updateFactionLeaderSelect, loadAddFactionPage,
    loadAddFactionMembersPage, loadChangeFactionNamePage, loadRemoveFactionMembersPage, loadSetFactionLeaderPage,
    getAddFactionMembersRequest, getAddFactionRequest, getDisbandFactionRequest, getRemoveFactionLeaderRequest,
    getRemoveFactionMembersRequest, getSetFactionLeaderRequest, getFactionSuperstarsHtml}